/* global Sys, Core, Services, Language */
Sys.ns("Core");

/**
 * The Custom Messages model.
 *
 * @class Core.CustomMessagesModel
 * @extends Core.Model
 */
Core.CustomMessagesModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.CustomMessagesModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    setupData: function() {
        this.roundEndQueue = [];
        this.immediateQueue = [];
        this.dialogsToWaitFor = [];
        this.storeData("isIdle", false);
        this.storeData("showingLoader", true);
    },

    /**
     * Add a dialog to the waiting list.
     *
     * @protected
     * @param {string} id The id of the unique dialog.
     * @returns {void}
     */
    addDialogToWaitFor: function(id) {
        this.dialogsToWaitFor.push(id);
    },

    /**
     * Remove a dialog from the waiting list.
     *
     * @protected
     * @param {string} id The id of the unique dialog.
     * @returns {void}
     */
    removeDialogToWaitFor: function(id) {
        var index = this.dialogsToWaitFor.indexOf(id);

        if (index !== -1) {
            this.dialogsToWaitFor.splice(index, 1);
        }
    },

    /**
     * Whether or not there are dialogs to wait for.
     *
     * @protected
     * @returns {boolean} If any dialogs are still in wait.
     */
    hasDialogsToWaitFor: function() {
        return this.dialogsToWaitFor.length > 0;
    },

    /**
     * Adds a dialog config.
     *
     * @protected
     * @param {Object} config The dialog config.
     * @returns {void}
     */
    addDialog: function(config) {
        if (config.immediate) {
            this.immediateQueue.push(config);
        }
        else {
            this.roundEndQueue.push(config);
        }
    },

    /**
     * Removes a dialog by id.
     *
     * @protected
     * @param {string} id The dialog id.
     * @returns {void}
     */
    removeDialog: function(id) {
        this.spliceDialogFromQueue(this.roundEndQueue, id);
        this.spliceDialogFromQueue(this.immediateQueue, id);
    },

    /**
     * Remove and return the dialog with the matching id from the queue.
     *
     * @private
     * @param {Array} queue The queue to remove it from.
     * @param {string} id The id of the dialog.
     * @returns {?Array} Spliced dialog.
     */
    spliceDialogFromQueue: function(queue, id) {
        var numElements = queue.length,
            i;

        for (i = 0; i < numElements; i++) {
            if (queue[i].id === id) {
                return queue.splice(i, 1);
            }
        }

        return null;
    },

    /**
     * Removes all request configs and returns them.
     *
     * @protected
     * @returns {Object[]} Request configs.
     */
    popAllImmediate: function() {
        return this.immediateQueue.splice(0, this.immediateQueue.length);
    },

    /**
     * Removes all request configs and returns them.
     *
     * @private
     * @returns {Object[]} Request configs.
     */
    popAllRoundEnd: function() {
        return this.roundEndQueue.splice(0, this.roundEndQueue.length);
    },

    /**
     * Removes all request configs.
     *
     * @protected
     * @returns {Object[]} Request configs.
     */
    popAll: function() {
        return this.popAllImmediate().concat(this.popAllRoundEnd());
    },

    /**
     * Whether or not there are messages to be shown immediately.
     *
     * @protected
     * @returns {boolean} If any messages to be shown immediately.
     */
    hasImmediate: function() {
        return this.immediateQueue.length > 0;
    },

    /**
     * Whether or not there are messages to be shown.
     *
     * @protected
     * @returns {boolean} If any messages to be shown.
     */
    hasDialogs: function() {
        return this.immediateQueue.length > 0 || this.roundEndQueue.length > 0;
    },

    /**
     * Get the close button configuration.
     *
     * @protected
     * @param {Object} scope The scope to execute the action in.
     * @returns {(Object|undefined)} Close button configuration or undefined if home is not available.
     */
    getCloseButtonConfig: function(scope) {
        if (Sys.utils.isHomeAvailable()) {
            return {
                scope: scope,
                text: Services.languageManager.getText(Language.Keys.btn_casino),
                action: function() {
                    scope.fireEvent("notify:dialogBoxClosed", { name: "netentExtendCustomError", button: "home" });

                    Sys.utils.goToLobby();
                }
            };
        }
        return undefined;
    },

    /**
     * Get the continue button configuration.
     *
     * @protected
     * @param {Object} scope The scope to execute the action in.
     * @param {boolean} [revert=false] If revert spin.
     * @returns {Object} Continue button configuration.
     */
    getContinueButtonConfig: function(scope, revert) {
        return {
            scope: scope,
            text: Services.languageManager.getText(Language.Keys.btn_continue),
            action: function() {
                scope.fireEvent("notify:dialogBoxClosed", { name: "netentExtendCustomError", button: "continue" });

                if (revert) {
                    scope.revertSpin();
                }
            }
        };
    }
};

Core.CustomMessagesModel = Sys.extend(Core.Model, Core.CustomMessagesModel, "Core.CustomMessagesModel");
